import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../index";
import { API_BASE_URL } from "../../constants";
import { Device, deviceTemp } from "./devicesApi";

export interface GetData {
  device: Device;
  startTime: Date;
  endTime: Date;
}

const batteryVoltageDataApi = createApi({
  reducerPath: "batteryVoltageData",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}/batteryvoltagedata`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
    }
  }),
  tagTypes: ["loadBatteryVoltageData"],
  endpoints(builder) {
    return {
      loadBatteryVoltageData: builder.mutation<deviceTemp[], GetData>({
        invalidatesTags: ["loadBatteryVoltageData"],
        query: parameters => {
          return {
            url: "/",
            method: "POST",
            body: {
              deviceId: parameters.device.id,
              startTime: parameters.startTime,
              endTime: parameters.endTime
            }
          };
        }
      })
    };
  }
});

export const { useLoadBatteryVoltageDataMutation } = batteryVoltageDataApi;
export { batteryVoltageDataApi };
